export const getParcel = state => state.ui.search.parcel;
export const getPagination = state => state.ui.search.pagination;
